import $ from "jquery";

import * as browserTTS from "./browserTTS";
import readlangClient from "./readlangClient";

export const play = async (language, text, loadedCallback?: () => void) => {
  let dataURI;
  if (window.READLANG.chromeExtension) {
    dataURI = (
      await readlangClient.request("GET", "/api/tts", {
        text,
        language,
      })
    ).data;
  }

  if (!languageSupported(language)) {
    loadedCallback?.();
    return;
  }

  /** @type {any} */
  let audio = $("#audioEle");
  if (audio.length === 0) {
    audio = $('<audio id="audioEle" style="display:none;">' + "</audio>");
    $("body").append(audio);
  }

  audio.children().remove();
  audio.append(
    $("<source />").attr(
      "src",
      dataURI ??
        "/api/tts?text=" +
          encodeURIComponent(text) +
          `&timezoneOffset=${new Date().getTimezoneOffset()}` +
          "&language=" +
          encodeURIComponent(language) +
          `&cacheBuster=${Date.now()}`
    )
  );
  (audio[0] as HTMLAudioElement).load();

  let playPromise;

  try {
    playPromise = (audio[0] as HTMLAudioElement).play();
  } catch (error) {
    // Don't send this error to Rollbar since there are thousands of them.
    // See: https://rollbar.com/duolingo/readlang/items/104
    // It can happen when using the Web Reader. In this case although the user has clicked on the
    // underlying document to translate the word, they may never have clicked directly on the
    // Readlang Web Reader toolbar, which runs within a separate iframe, and therefore the browser
    // can refuse to play the sound via this code originating from the Web Reader iframe.
    console.error("Unable to play sound: ", error);
  }

  if (playPromise !== undefined) {
    playPromise.catch((error) =>
      console.error("Unable to play sound: ", error)
    );
  }

  loadedCallback?.();
};

const supportedLanguages = [
  "af",
  "sq",
  "am",
  "ar",
  "hy",
  "as",
  "az",
  "eu",
  "bn",
  "bs",
  "bg",
  "my",
  "ca",
  "zh",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "tl",
  "fi",
  "fr",
  "gl",
  "ka",
  "de",
  "el",
  "gu",
  "iw",
  "hi",
  "hu",
  "is",
  "id",
  "ga",
  "it",
  "ja",
  "jv",
  "kn",
  "kk",
  "km",
  "ko",
  "lo",
  "lv",
  "lt",
  "mk",
  "ms",
  "ml",
  "mt",
  "mr",
  "mn",
  "ne",
  "no",
  "or",
  "ps",
  "fa",
  "pl",
  "pt",
  "pa",
  "ro",
  "ru",
  "sr",
  "si",
  "sk",
  "sl",
  "so",
  "es",
  "su",
  "sw",
  "sv",
  "ta",
  "te",
  "th",
  "zh-TW",
  "tr",
  "uk",
  "ur",
  "uz",
  "vi",
  "cy",
  "zu",
];

export const languageSupported = (language) =>
  supportedLanguages.indexOf(language) !== -1;

export const getSupportedLanguages = () => supportedLanguages;

export const bookmarkletLanguageSupported = async (language) => {
  if (window.READLANG.chromeExtension) {
    return (await browserTTS.getSupportedLanguages()).has(language);
  }

  return languageSupported(language);
};
